import SideBarOptions from "base/src/utils/SideBarOptions";

export const sideBarOptions: Array<SideBarOptions> = [
  {
    Title: 'Central',
    LinkTo: '/central',
    Icon: 'mdi:view-dashboard',
    home: true
  },
  {
    Title: 'Perfil',
    LinkTo: '/perfil',
    Icon: 'mdi:account-circle',
    isDev: true
  },
]
